export const DEFAULT_IP_SEARCHING_AGENT_NAME = 'eureka_ip_searching_agent';

const IP_SEARCHING_AGENT_NAME_BY_ROUTE_MATCHERS: Array<[RegExp, string]> = [
    [/\/novelty-check-report(?:\/|$)/, 'ip_searching_novelty_search'],
    [/\/(?:fto-report|fto-pro)(?:\/|$)/, 'ip_searching_fto'],
    [/\/(?:design-fto|image-fto-search)(?:\/|$)/, 'ip_searching_design_fto'],
];

const HOME_AGENT_NAME_BY_QUERY: Record<string, string> = {
    'novelty-check-report': 'ip_searching_novelty_search',
    'fto-pro': 'ip_searching_fto',
    'design-fto': 'ip_searching_design_fto',
};

/**
 * 根据当前 URL 或路由路径获取 IP Searching agent 名称
 */
export function getAgentNameByRoute(routeOrUrl?: string) {
    const route = getComparableRoute(routeOrUrl ?? getCurrentHref());

    if (route.path === '/home' || route.path === '/home/') {
        return getHomeAgentName(route.searchParams);
    }

    const match = IP_SEARCHING_AGENT_NAME_BY_ROUTE_MATCHERS.find(([pattern]) => pattern.test(route.path));

    return match?.[1] ?? DEFAULT_IP_SEARCHING_AGENT_NAME;
}

function getHomeAgentName(searchParams: URLSearchParams) {
    const agentNames = searchParams.getAll('agent');
    if (agentNames.length !== 1) {
        return HOME_AGENT_NAME_BY_QUERY['novelty-check-report'];
    }

    return HOME_AGENT_NAME_BY_QUERY[agentNames[0]] ?? HOME_AGENT_NAME_BY_QUERY['novelty-check-report'];
}

function getComparableRoute(routeOrUrl: string) {
    const url = createUrl(routeOrUrl);
    const routeUrl = url.hash.startsWith('#/')
        ? createUrl(url.hash.slice(1))
        : url;

    return {
        path: routeUrl.pathname.toLowerCase(),
        searchParams: routeUrl.searchParams,
    };
}

function createUrl(routeOrUrl: string) {
    try {
        return new URL(routeOrUrl, window.location.origin);
    } catch {
        return new URL(`https://example.com${routeOrUrl.startsWith('/') ? '' : '/'}${routeOrUrl}`);
    }
}

function getCurrentHref() {
    return window.location.href;
}
